/* Stylesheet */

.table {
  box-shadow: var(--ion-box-shadow);
  border-radius: 8px;
  overflow: hidden;
}
